export enum CustomsDataDocumentTypeEnum {
  COMMERCIAL = 'COMMERCIAL',
  PROFORMA = 'PROFORMA'
}



// WEBPACK FOOTER //
// ./src/app/model/customs-data-document-type-enum.ts